(function () {
  'use strict';

  document.querySelectorAll('[data-sm-reviews]').forEach(function (widget) {
    var cards = Array.prototype.slice.call(widget.querySelectorAll('.sm-review-card'));
    var more = widget.querySelector('[data-sm-reviews-more]');
    var filterButtons = Array.prototype.slice.call(widget.querySelectorAll('[data-sm-filter]'));
    var allButton = widget.querySelector('[data-sm-filter-all]');
    var activeRating = null;
    var visibleLimit = 5;

    function updateCards() {
      var matching = cards.filter(function (card) {
        return !activeRating || card.getAttribute('data-rating') === activeRating;
      });
      cards.forEach(function (card) {
        var isMatch = !activeRating || card.getAttribute('data-rating') === activeRating;
        var matchIndex = matching.indexOf(card);
        card.hidden = !isMatch || matchIndex >= visibleLimit;
      });
      if (more) more.hidden = matching.length <= visibleLimit;
      if (allButton) allButton.setAttribute('aria-pressed', activeRating ? 'false' : 'true');
      filterButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-sm-filter') === activeRating ? 'true' : 'false');
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.getAttribute('data-sm-filter');
        activeRating = activeRating === selected ? null : selected;
        visibleLimit = 5;
        updateCards();
      });
    });
    if (allButton) {
      allButton.addEventListener('click', function () {
        activeRating = null;
        visibleLimit = 5;
        updateCards();
      });
    }
    if (more) {
      more.addEventListener('click', function () {
        visibleLimit += 5;
        updateCards();
      });
    }
    updateCards();

    var form = widget.querySelector('#sm-review-form');
    var ratingField = widget.querySelector('[data-sm-review-rating]');
    if (form && ratingField) {
      var storageKey = 'sm-review-rating:' + (widget.getAttribute('data-product-handle') || 'product');
      var errorPanel = form.querySelector('.sm-review-form__errors');
      var postedPanel = form.querySelector('[data-sm-review-posted]');
      try {
        var storage = window.sessionStorage;
        if (postedPanel) {
          storage.removeItem(storageKey);
        } else if (errorPanel) {
          var savedRating = storage.getItem(storageKey);
          var savedInput = savedRating && ratingField.querySelector('input[value="' + savedRating + '"]');
          if (savedInput) savedInput.checked = true;
          storage.removeItem(storageKey);
        } else {
          storage.removeItem(storageKey);
        }
        form.addEventListener('submit', function () {
          var selected = ratingField.querySelector('input:checked');
          if (selected) {
            try {
              storage.setItem(storageKey, selected.value);
            } catch (_submitStorageError) {
              /* The form still submits without storing the rating. */
            }
          }
        });
      } catch (_storageError) {
        /* The form remains usable when browser storage is unavailable. */
      }
    }

    var photoLinks = Array.prototype.slice.call(widget.querySelectorAll('[data-sm-review-photo]'));
    if (!photoLinks.length || !document.createElement('dialog').showModal) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'sm-review-lightbox';
    dialog.setAttribute('aria-label', 'Customer review photos');
    dialog.innerHTML = '<button type="button" class="sm-review-lightbox__close" aria-label="Close photo viewer">×</button>' +
      '<button type="button" class="sm-review-lightbox__nav sm-review-lightbox__nav--prev" data-sm-photo-prev aria-label="Previous photo">‹</button>' +
      '<img class="sm-review-lightbox__image" alt="">' +
      '<button type="button" class="sm-review-lightbox__nav sm-review-lightbox__nav--next" data-sm-photo-next aria-label="Next photo">›</button>' +
      '<p class="sm-review-lightbox__caption" aria-live="polite"></p>';
    document.body.appendChild(dialog);

    var image = dialog.querySelector('.sm-review-lightbox__image');
    var caption = dialog.querySelector('.sm-review-lightbox__caption');
    var closeButton = dialog.querySelector('.sm-review-lightbox__close');
    var previousButton = dialog.querySelector('[data-sm-photo-prev]');
    var nextButton = dialog.querySelector('[data-sm-photo-next]');
    var currentPhotos = [];
    var currentIndex = 0;
    var returnFocus = null;

    function showPhoto(index) {
      if (!currentPhotos.length) return;
      currentIndex = (index + currentPhotos.length) % currentPhotos.length;
      var link = currentPhotos[currentIndex];
      var thumb = link.querySelector('img');
      image.src = link.href;
      image.alt = thumb ? thumb.alt : 'Customer review photo';
      caption.textContent = 'Photo ' + (currentIndex + 1) + ' of ' + currentPhotos.length;
      previousButton.hidden = currentPhotos.length < 2;
      nextButton.hidden = currentPhotos.length < 2;
    }

    photoLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        var card = link.closest('.sm-review-card');
        currentPhotos = card ? Array.prototype.slice.call(card.querySelectorAll('[data-sm-review-photo]')) : [link];
        returnFocus = link;
        showPhoto(currentPhotos.indexOf(link));
        dialog.showModal();
        closeButton.focus();
      });
    });

    closeButton.addEventListener('click', function () { dialog.close(); });
    previousButton.addEventListener('click', function () { showPhoto(currentIndex - 1); });
    nextButton.addEventListener('click', function () { showPhoto(currentIndex + 1); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' && currentPhotos.length > 1) showPhoto(currentIndex - 1);
      if (event.key === 'ArrowRight' && currentPhotos.length > 1) showPhoto(currentIndex + 1);
    });
    dialog.addEventListener('close', function () {
      image.removeAttribute('src');
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
      returnFocus = null;
      currentPhotos = [];
    });
  });
})();
